<div class="service-mgt-group">
  <div class="container no-padding">
    <div class="row">
      <div class="col pm-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>